var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.22 205.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#666666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.64,
    cy: 102.51,
    r: 97.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.64,
    cy: 102.51,
    r: 76.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.64,184.41a81.88,81.88,0,0,1-78.5-104.8,81.79,81.79,0,1,1,78.5,104.8Zm-.1-152.9a71.08,71.08,0,0,0-19.8,139.3,72,72,0,0,0,19.9,2.9,71,71,0,0,0,19.9-139.2A65.57,65.57,0,0,0,102.54,31.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.54,205.11a101.58,101.58,0,0,1-28.7-4.1,102.56,102.56,0,1,1,118.7-147.7,101.54,101.54,0,0,1,8.5,78C188,176,146.94,205.11,102.54,205.11Zm.1-194.4a92,92,0,1,0,25.7,3.7A92,92,0,0,0,102.64,10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.44,91a50.55,50.55,0,0,0,8.6,6.5,87.47,87.47,0,0,1,9.6,6.9,19.79,19.79,0,0,1,5.5,7.8c1.3,3.1,1.3,6.8.1,10.9-1.6,5.3-4.6,9.1-9.2,11.4a24,24,0,0,1-11.8,2.3,5.5,5.5,0,0,0-5.5,3.9l-1.1,3.6a5.43,5.43,0,0,1-6.7,3.7h0a5.43,5.43,0,0,1-3.7-6.7l1-3.6a5.45,5.45,0,0,0-2.6-6.3,43.07,43.07,0,0,1-7.5-5.1,51.12,51.12,0,0,1-5.7-5.7,5.47,5.47,0,0,1,.2-7.11l1.7-1.79a5.5,5.5,0,0,1,8.2.2,52.14,52.14,0,0,0,5.3,5.2,31.17,31.17,0,0,0,10.6,6,12.8,12.8,0,0,0,7.4.4,5.92,5.92,0,0,0,3.4-8.5,12.51,12.51,0,0,0-3.5-3.8,66.34,66.34,0,0,0-6.5-4.3,89.49,89.49,0,0,1-9.6-6.7,19.38,19.38,0,0,1-5.5-7.6c-1.3-3.1-1.3-6.6-.1-10.7A17.15,17.15,0,0,1,92.74,71a22.67,22.67,0,0,1,11.5-2.5,5.49,5.49,0,0,0,5.4-3.9l.8-2.9a5.43,5.43,0,0,1,6.7-3.7h0a5.43,5.43,0,0,1,3.7,6.7l-.8,2.6a5.4,5.4,0,0,0,2.7,6.3c2,1.1,3.9,2.2,5.8,3.5,1.4,1,2.6,2,3.8,3a5.5,5.5,0,0,1,.5,7.7l-1.9,2.2a5.41,5.41,0,0,1-7.7.4,49.06,49.06,0,0,0-5.1-3.9,35.38,35.38,0,0,0-8.9-4.5,12.75,12.75,0,0,0-6.3-.4,4.57,4.57,0,0,0-3.3,3.4A6.55,6.55,0,0,0,101.44,91Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.f33ef50e303d1929ac09209a788d98a3.svg";
export { ForwardRef as ReactComponent };